import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RoomItem from './Items/RoomItem';
import { changeIsSummaryOpened } from '../../model/configuratorSlice';
import SummaryPanel from '../Summary/SummaryPanel';
import DescriptionPanel from '../DescriptionPanel/DescriptionPanel';
import MainMenu from '../MainMenu/MainMenu';
import useWindowSize from '../../hooks/useWindowSize';
import SummaryPanelMobile from '../Summary/SummaryPanelMobile';
import { getPriceText } from '../../utils/currencyFormatter';
import { MobileWidth } from '../../model/constants';

const RoomsPanel = () => {
  const rooms = useSelector(state => state.configurator.rooms);
  const categories = useSelector(state => state.configurator.categories);
  const currentRoom = useSelector(state => state.configurator.currentRoom);
  const legalSettings = useSelector(state => state.configurator.legalSettings);
  const totalPrice = useSelector(state => state.configurator.totalPrice);
  const windowsSize = useWindowSize();
  const dispatch = useDispatch();

  const getCategoriesForRoom = (room) => {
    const roomCategories = [];

    room.categories.forEach((roomCategory) => {
      const roomCategoryItem = categories.filter(cat => cat.id === roomCategory.id)[0] || null;

      if (roomCategoryItem !== null && roomCategory.hideInMenu !== true) {
        roomCategories.push(roomCategoryItem);
      }
    });

    return roomCategories;
  };

  const isSmallScreen = () => windowsSize.width <= MobileWidth;


  return (
    <div className="rooms-panel">
      {/* <div className="divider-top" /> */}
      <div className="container-rooms" id="container-rooms">
        {rooms.map((room, index) => (
          <RoomItem
            id={room.id}
            name={room.name}
            nextRoomName={index < rooms.length - 1 ? rooms[index + 1].name : ''}
            categories={getCategoriesForRoom(room)}
            isFirstItem={rooms[0].id === room.id}
            isLastItem={rooms[rooms.length - 1].id === room.id}
          />
          ))}
      </div>
      <div className="summary-container">
        <div className="total-price-text-container">
          <div className="total-price-text">
            <div className="title">Precio total</div>
            <div className="vat">(sin IVA)</div>
          </div>
          <div className="total-price-value">{getPriceText(totalPrice)}</div>
        </div>
        <button type="button" className="summary-button" onClick={() => dispatch(changeIsSummaryOpened(true))}>
          <span>Ver Resumen</span>
        </button>
      </div>
      <div className="container-privacy-pages">
        <button
          className="legal-button"
          type="button"
          onClick={() => window.open(legalSettings.legalAdviceUrl)}
        ><span>Aviso Legal</span>
        </button>
        <div className="separator"> -</div>
        <button
          className="legal-button"
          type="button"
          onClick={() => window.open(legalSettings.privacyPolicyUrl)}
        ><span>Política de privacidad</span>
        </button>
        {/* <div className="separator"> -</div>
        <button
          className="legal-button"
          type="button"
          onClick={() => window.open(legalSettings.cookiesUrl)}
        ><span>Cookies</span>
        </button> */}
      </div>
      <DescriptionPanel />
      <MainMenu />
      {!isSmallScreen() ? <SummaryPanel /> : <SummaryPanelMobile />}
    </div>
);
};

export default RoomsPanel;
